import i18next from 'i18next'
import getUserLanguage from 'src/utils/getUserLanguage'
import type { IsoLanguage } from 'src/types/language'

type Options = {
  bundle?: string
}

type Result = {
  i18next: any
  userLanguage: IsoLanguage
}

const userLanguage = getUserLanguage()

const addBundle = async ({ bundle }: Options) => {
  try {
    if (bundle && !userLanguage.includes('ru')) {
      const translation = await import(`www/${bundle}/locales/${userLanguage}.trans`)

      i18next.addResourceBundle(userLanguage, userLanguage, translation.default)
    }
  } catch { /* Empty */ }
}

const initI18n = async (opts: Options = {}): Promise<Result> => {
  if (i18next.isInitialized) {
    await addBundle(opts)

    return { i18next, userLanguage }
  }

  await i18next.init({
    lng: userLanguage,
    resources: {},
    interpolation: {
      prefix: '{',
      suffix: '}',
    },
  })

  await addBundle(opts)

  return { i18next, userLanguage }
}

export default initI18n
